export default __webpack_public_path__ + "static/media/img-aorus-falcon-warriors.18c32ad5.jpg";